module.exports = __webpack_public_path__ + "img/pwa_iOS_02.6b78d1db.png";